import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReceiveEmailService } from './services';

@NgModule({
  imports: [CommonModule],
  providers: [ReceiveEmailService],
})
export class PackagesEmailWebModule {}
